import { Box, Table } from "@chakra-ui/react";
import { ProductAdjustment } from "@/shared/core-product-adjustments";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";

interface AdjustmentProductsModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedProductAdjustment: ProductAdjustment;
}

const headerProps = {
  fontSize: "xs",
  fontWeight: "semibold",
  letterSpacing: "wider",
  textTransform: "uppercase",
  color: "fg.muted",
} as const;

const AdjustmentProductsModal: React.FC<AdjustmentProductsModalProps> = ({
  isOpen,
  onClose,
  selectedProductAdjustment,
}) => {
  return (
    <DialogRoot isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <DialogContent>
        <DialogCloseTrigger />
        <DialogHeader borderBottomWidth="1px" borderColor="border">
          <DialogTitle>Productos del reajuste</DialogTitle>
        </DialogHeader>
        <DialogBody pt={4}>
          <Box borderWidth="1px" borderColor="border" rounded="lg">
            <Table.Root size="sm" variant="line">
              <Table.Header bg="bg.subtle">
                <Table.Row>
                  <Table.ColumnHeader {...headerProps}>
                    ID Producto
                  </Table.ColumnHeader>
                  <Table.ColumnHeader {...headerProps}>
                    Descripción
                  </Table.ColumnHeader>
                  <Table.ColumnHeader {...headerProps} textAlign="end">
                    Cantidad reajustada
                  </Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {selectedProductAdjustment?.products.map((product) => (
                  <Table.Row key={product.id}>
                    <Table.Cell fontFamily="mono" fontSize="xs">
                      {product.id}
                    </Table.Cell>
                    <Table.Cell>{product.description}</Table.Cell>
                    <Table.Cell textAlign="end" fontWeight="semibold">
                      {product.adjustmentProduct?.quantity}
                    </Table.Cell>
                  </Table.Row>
                ))}
                {selectedProductAdjustment?.products.length === 0 && (
                  <Table.Row>
                    <Table.Cell
                      colSpan={3}
                      textAlign="center"
                      py={8}
                      color="fg.muted"
                    >
                      No hay productos asignados a este ajuste.
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table.Root>
          </Box>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};

export default AdjustmentProductsModal;
